import React from 'react';
import { I_FlightList } from '@Redux/search/interfaces';
import styles from '../styles.module.scss';

interface I_Props {
    flights: I_FlightList[];
    isBack: boolean;
}

const FlightList: React.FC<I_Props> = ({ flights, isBack }) => {
    const timeToCH = (HrMin: string) => {
        const HrMinArray = HrMin.split(':');

        const hour = Number(HrMinArray[0]);
        const min = Number(HrMinArray[1]);

        return `${hour}小時${min}分鐘`;
    };

    return (
        <ul className={styles[`flights__sub__list`]}>
            {flights.map((flight: I_FlightList, i: number) => (
                <li key={i} className={styles[`flights__sub__item`]}>
                    <div className={styles[`flights__sub__item__main`]}>
                        <div className={styles[`flights__sub__item__time-airport`]}>
                            <div className={styles[`flights__sub__item__time-airport__departs`]}>
                                <div>{`${flight.DepartureDate} ${flight.DepartTime}`}</div>
                                <div>{flight.DepartureAirport}</div>
                            </div>
                            <div className={styles[`flights__sub__item__time-airport__desns`]}>
                                <div>{`${flight.ArriveDate} ${flight.ArriveTime}`}</div>
                                <div>{flight.ArriveAirport}</div>
                            </div>
                        </div>
                        <div
                            className={styles[`flights__sub__item__flight-no`]}
                        >{`${flight.Airline} ${flight.FlightNo}`}</div>
                    </div>
                    <div className={styles[`flights__sub__item__notes`]}>
                        <div className={styles[`flights__sub__item__time`]}>{`飛行時間約${timeToCH(
                            flight.FlightTime
                        )}`}</div>
                        {isBack && i === flights.length - 1 && (
                            <div
                                className={styles[`flights__sub__item__arrive`]}
                            >{`抵達台灣日期${flight.ArriveDate}`}</div>
                        )}
                    </div>
                </li>
            ))}
        </ul>
    );
};

export default FlightList;
